<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Button, Input, Text } from '@Shelly/shelly-design-system/index';
	import { controlBleDevice } from 'src/stores/features/ble/control-device';
	import { app, os } from 'src/stores/session/native-bridge';
import { hideBluetoothSettingsToast } from 'src/stores/ui/calibration-modals';
	import {
		control_bluetooth_device_ios,
		control_bluetooth_general_ios,
	} from 'src/services/native_container_requests_ios';
	import {
		control_bluetooth_device_android,
		control_bluetooth_general_android,
	} from 'src/services/native_container_requests_android';
	import { valueOutOfRange } from 'src/helpers/utilities';
	import { bulkUpdate } from '../ApplicationSettings/app_settings_helper';
	import { BLU_STATUS } from 'src/types/requests/settings/blu_status';

	export let device;

	const min = 5;
	const max = 300;
	let measureInterval: any = device?.measureInterval || 30;
	let initialized = false;

	const onSave = () => {
		hideBluetoothSettingsToast.set(false);
		if ($controlBleDevice.connectionState === 2) {
			$os === 'IOS'
				? control_bluetooth_general_ios(
						device.id,
						'setMeasureInterval',
						'measureInterval',
						measureInterval,
					)
				: control_bluetooth_general_android(
						device.id,
						'setMeasureInterval',
						'measureInterval',
						measureInterval,
					);

			bulkUpdate(device.id, { measureInterval });
		} else {
			$os === 'IOS'
				? control_bluetooth_device_ios(device.id, 'connect')
				: control_bluetooth_device_android(device.id, 'connect');
		}
	};

	$: switch ($controlBleDevice.currentStatusIndex) {
		// after receiving one of the statuses below remove the initialized state
		case BLU_STATUS.UNHANDLED_STATE:
		case BLU_STATUS.BUTTON_PRESS_REQUIRED:
		case BLU_STATUS.CONNECT_TO_DEVICE:
		case BLU_STATUS.DISCONNECT_FROM_DEVICE:
			initialized = false;
			break;
		// after receiving one of the statuses below add the initialized state
		case BLU_STATUS.DEVICE_OTA_AVAILABLE:
		case BLU_STATUS.DEVICE_OTA_REQUIRED:
		case BLU_STATUS.DEVICE_PROCESSED:
		case BLU_STATUS.DISTANCE_RANGE_SET:
		case BLU_STATUS.INTERVAL_MEASURE_SET:
		case BLU_STATUS.MEASURE_VIBRATION_ENABLED:
		case BLU_STATUS.MEASURE_VIBRATION_DISABLED:
			initialized = true;
			break;
		default:
			break;
	}

	$: error = valueOutOfRange(measureInterval, min, max)
		? $format('error_out_of_range', {
				default: `Value ${measureInterval} is out of range. Please provide a value within the limits. (${min} — ${max})`,
				values: {
					value: measureInterval,
					min,
					max,
					unit: $format('timer_text_sec', { default: 'sec' }),
				},
			})
		: '';
</script>

<Text styleType="body-small" class="mb-s">
	{$format('text_set_measurement_interval', {
		default: 'Set the measurement interval in seconds between valid measurements.',
	})}
</Text>

<Input
	aria-label={$format('input_measurement_interval', {
		default: 'Enter the measurement interval. Value must be between {min} — {max}!',
		values: { min, max },
	})}
	icon="fas fa-timer"
	class="mb-m"
	bind:value={measureInterval}
	type="number"
	step={1}
	{min}
	{max}
	info={$format('min_max_error_description', {
		default: 'Value must be between {min} and {max}.',
		values: { min, max },
	})}
	{error}
	id="input-yu17f63"
/>

<Button disabled={!initialized || !$app || error} size="m" width="full" on:click={onSave}>
	{$format('button_save', { default: 'Save' })}
</Button>
